export const SERVER_INTERVAL_MS = 30000;
export const AUTO_REFRESH_FLIGHT_OVERLAY_MS = 60000;
export const TIMEOUT_DELAY_MS = 15 * 60000;
